(function () {
    'use strict';
    var app = angular.module('app');
    var apiUrl = "https://localhost:8417";

    app.factory('authenticationOriginService', [authenticationOriginService]);

    function authenticationOriginService() {

        var service = {
            getOriginInfo: getOriginInfo
        }

        // Return the service
        return service;

        function getOriginInfo() {
            var origin = angular.copy(window.authenticationOrigin);
            return origin;
        }
    }

})();